import { useEffect, useState } from 'react';

import { Board, Council } from 'types';

import { BoardEntityTypes } from 'types/Board';
import { getStatusCountByBoards } from '../utils/getStatusCountByBoards';

import { StatusCount } from '../types/StatusCount';
import { getSummaryCards } from '../utils/getSummaryCards';
import { SummaryCard } from '../types/SummaryCard';
import { CardToShow } from '../types/CardsToShow';

type UseGetBoardsListHeaderProps = {
  boardType: BoardEntityTypes;
  boards: Council[] | Board[];
  cardsToShow: CardToShow;
};

export const useGetSummaryCards = ({
  boardType,
  boards,
  cardsToShow,
}: UseGetBoardsListHeaderProps) => {
  const [summaryCards, setSumaryCards] = useState<SummaryCard[]>([]);

  useEffect(() => {
    const boardsByStatus: StatusCount = getStatusCountByBoards(boards);

    const summaryCards = getSummaryCards(
      boardsByStatus,
      cardsToShow,
      boardType
    );
    setSumaryCards(summaryCards);
  }, [boardType, boards, cardsToShow]);

  return {
    data: {
      summaryCards,
    },
  };
};
